<template>
  <div>
    <div
      v-if="mediaType!=='midi'"
      class="ksm-player__controls-row"
      style="border-bottom:0; background-color:#d9d9da;"
    >
      <div class="ksm-player-btn"></div>
      <div
        class="ksm-player__row-middle"
        style="border:0;background-color:#d9d9da; position:relative"
      >
        <div
          class="ksm-flex"
          style="position: absolute; width:100%; overflow:hidden; height:100%; padding:0 15px"
        >
          <svg
            version="1.1"
            height="500"
            viewBox="0 0 3000 500"
            preserveAspectRatio="xMinYMin meet"
          >
            <g v-for="(d,i) of svgData" :key="i">
              <rect
                v-tooltip="d.tooltipOpt"
                :class="d.class"
                :x="d.x"
                :width="d.width"
                height="100%"
              />
            </g>
          </svg>
        </div>
      </div>
      <div class="ksm-player-btn" style="background-color:#d9d9da;"></div>
    </div>
    <div class="ksm-player__controls-row">
      <g-play-btn :isPlaying="isPlaying" @click="play(1)" :style="playBtnDisable?'opacity:0.2':''"></g-play-btn>
      <div class="ksm-player__row-middle">
        <input class="ksm-player__seekbar" type="range" value="0" />
      </div>
      <button type="button" class="ksm-player-btn ksm-player-btn ksm-player-mute">
        <img src="~icons/loud-volume.png" />
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Steuerleiste
 */

export default {
  props: [
    "media",
    "mediaName",
    "mediaType",
    "duration",
    "currentTime",
    "playBtnDisable"
  ],
  components: {},
  data() {
    return {
      isPlaying: false,
      localDuration: 0,
      seekbarlock: false,
      w: 0
    };
  },
  watch: {
    mediaName() {
      this.isPlaying = false;
    },
    currentTime(t) {
      if (this.mediaType === "midi") {
        this.seekbar.value = t;
      }
    },
    duration(d) {
      if (this.mediaType === "midi") {
        this.seekbar.max = d;
      }
    }
  },

  computed: {
    ursonateData() {
      return this.$store.state.ursonateData;
    },
    ursonateData2() {
      return this.$store.state.ursonateData2;
    },
    svgData() {
      if (
        !this.ursonateData ||
        !this.ursonateData2 ||
        !this.localDuration ||
        this.mediaType === "midi"
      ) {
        return;
      }
      const w = this.w;
      const duration = this.localDuration;
      const factor = 3000 / duration;
      const ursonateData2 = this.ursonateData2;

      const themen = this.ursonateData
        .filter(d => d["medien"] === this.mediaName)
        .map((d, i) => {
          const arr = d["timestamp"].split("-");
          let von = arr[0];
          let bis = arr[1];
          let von2, bis2;
          von =
            parseFloat(von.split(":")[0]) * 60 + parseFloat(von.split(":")[1]);
          bis =
            parseFloat(bis.split(":")[0]) * 60 + parseFloat(bis.split(":")[1]);
          let duration = bis - von;
          let duration2;
          let playbackRate;

          //video von2 bis2
          const ursonateData2Item = ursonateData2.find(
            d2 => d2.ID - d.ID === 0
          );
          if (this.mediaName !== "Film" && ursonateData2Item) {
            const arr2 = ursonateData2Item["timestamp2"].split("-");
            von2 = arr2[0];
            bis2 = arr2[1];
            von2 =
              parseFloat(von2.split(":")[0]) * 60 +
              parseFloat(von2.split(":")[1]);
            bis2 =
              parseFloat(bis2.split(":")[0]) * 60 +
              parseFloat(bis2.split(":")[1]);
            duration2 = bis2 - von2;
            playbackRate = duration2 / duration;
          }
          // const style = "transform:translate(" + von * factor + "px,0); ";
          const width = (bis - von) * factor + "px";
          return {
            von: von,
            bis: bis,
            von2: von2,
            bis2: bis2,
            duration: duration,
            duration2: duration2,
            playbackRate: playbackRate,
            title: d.thema,
            tooltipOpt: {
              content: d.thema,
              placement: "top-center",
              classes: ["info"]
            },
            currentTime: null,
            class: d.thema.replace(" ", "-").toLowerCase(),
            // style: style,
            docID: d.docID,
            x: von * factor,
            width: width
          };
        });
      // console.table(themen);
      return themen;
    }
  },
  mounted: function() {
    const vue = this;
    const mediaType = this.mediaType;
    if (this.mediaType === "midi") {
      this.setMidiPlayer();
    } else {
      this.setNormalPlayer();
    }

    this.$store.state.eventBus.$on(mediaType + "-play", function(currentTime) {
      if (!vue.isPlaying) {
        if (currentTime !== undefined && currentTime !== null) {
          vue.media.currentTime = currentTime;
        }
        vue.play();
      }
    });

    if (mediaType === "video") {
      this.$store.state.eventBus.$on(mediaType + "-sync", function({
        playbackRate,
        currentTime,
        isPlaying
      }) {
        // console.log("视频", currentTime, playbackRate);
        vue.media.playbackRate = playbackRate;
        vue.media.currentTime = currentTime;
        if (!vue.isPlaying && isPlaying) {
          vue.play();
        }
      });
    }

    this.$store.state.eventBus.$on(mediaType + "-pause", function(currentTime) {
      if (vue.isPlaying) {
        vue.play();
      }
    });
  },
  methods: {
    setMidiPlayer() {
      const vue = this;
      const seekbar = this.$el.querySelector(".ksm-player__seekbar");
      this.seekbar = seekbar;
      seekbar.addEventListener("change", function(e) {
        e.preventDefault();
        vue.$emit("seekbarChange", seekbar.value);
      });
      if (this.duration) {
        seekbar.max = this.duration;
      }
    },
    setNormalPlayer() {
      const vue = this;
      const media = this.media;
      const mediaName = this.mediaName;
      const seekbar = this.$el.querySelector(".ksm-player__seekbar");
      vue.w = this.$el.querySelector(".ksm-player__row-middle").clientWidth;
      this.seekbar = seekbar;
      media.addEventListener("loadedmetadata", function(e) {
        e.preventDefault();
        const duration = media.duration;
        vue.localDuration = duration;
        vue.seekbar.max = duration;
      });
      media.addEventListener("timeupdate", function(e) {
        if (vue.seekbarlock) {
          return;
        }
        e.preventDefault();
        const t = parseFloat(media.currentTime);
        vue.seekbar.value = t;

        let d;
        if (vue.svgData) {
          d = vue.svgData.find(d => {
            return t >= d.von && t <= d.bis;
          });
          if (d) {
            d.currentTime = t;
          }
        }
        if (mediaName.indexOf("Audio") === 0) {
          vue.$emit("audioChange", { d: d, isPlaying: vue.isPlaying });
        } else if (mediaName.indexOf("Film") === 0) {
          vue.$emit("videoPlaying", d);
        }
      });
      media.addEventListener("ended", function(e) {
        console.log("ended");
      });
      seekbar.addEventListener("mousedown", function(e) {
        vue.seekbarlock = true;
      });
      seekbar.addEventListener("mouseup", function(e) {
        vue.seekbarlock = false;
      });
      seekbar.addEventListener("change", function(e) {
        e.preventDefault();
        vue.seekbar.max = media.duration;
        media.currentTime = seekbar.value;
        if (!vue.isPlaying) {
          // vue.play();
        }
      });
    },
    play(playbackRate) {
      if (this.mediaType === "video" && playbackRate) {
        if (this.playBtnDisable) {
          return;
        }
        this.media.playbackRate = playbackRate;
      }
      if (this.mediaType === "midi") {
        this.playMidi();
      } else {
        this.playNormal();
      }
    },

    playMidi() {
      if (this.isPlaying) {
        this.$emit("playPause", true);
      } else {
        this.$emit("playPause");
      }
      this.isPlaying = !this.isPlaying;
    },

    playNormal() {
      if (this.isPlaying) {
        this.$emit("playPause", true);
        this.media.pause();
      } else {
        this.media.play();
        this.$emit("playPause");
      }
      this.isPlaying = !this.isPlaying;
    }
  }
};
</script>

<style lang="scss" >
$btnWidth: 20px;
$btnHeight: 20px;
$barHeight: 22px;

.ksm-player__textbar {
  height: $barHeight;
  border: 1px solid $gray2;
  border-bottom: 0px;
  background-color: $gray5;
  border-radius: 2px;
}

.ksm-player__controls-row {
  height: $barHeight;
  @extend .ksm-flex-y-center;
  border: 1px solid $gray2;

  input[type="range"] {
    -webkit-appearance: none;
    background: transparent;
    width: 100%;
    margin: 0 5px;
  }

  input[type="range"]:focus {
    outline: none;
  }

  input[type="range"]::-webkit-slider-runnable-track {
    width: 100%;
    height: 8px;
    cursor: pointer;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
    background: white;
    border-radius: 10px;
    border: 0.2px solid rgba(1, 1, 1, 0);
  }

  //value point
  input[type="range"]::-webkit-slider-thumb {
    height: 15px;
    width: 15px;
    border-radius: 50px;
    background: white;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -3.5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
    // box-shadow: -100vw 0 0 100vw dodgerblue;
  }
}

.ksm-player-btn {
  width: $btnWidth;
  height: $btnHeight;
  @extend .ksm-flex-xy-center;
  padding: 0;
  border: 0;
  img {
    width: 80%;
    height: 80%;
  }
}

.ksm-player__row-middle {
  border-left: 1px solid $gray2;
  border-right: 1px solid $gray2;
  height: 100%;
  flex: 1;
  @extend .ksm-flex-y-center;

  input {
    flex: 1;
  }
}
</style>


// WEBPACK FOOTER //
// PlayerControls.vue?051d4537